/** @format */

export default {
	setAvailability( availability, count, query ) {
		return {
			type: 'SET_AVAILABILITY',
			availability,
			count,
			query: query || {},
		};
	},
	setAvailabilityError( query ) {
		return {
			type: 'SET_AVAILABILITY_ERROR',
			query: query || {},
		};
	},
	fetchFromAPI( path ) {
		return {
			type: 'FETCH_FROM_API',
			path: path.path,
		};
	},
	nextAvailabilityPage( query ) {
		return {
			type: 'NEXT_AVAILABILITY_PAGE',
			query: query || {},
		};
	},
};
